export default {
      id: "i-logo-clean-new-usage",
      viewBox: "0 0 125 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-clean-new",
      toString: function () {
        return this.url;
      }
    }